import * as Sentry from '@sentry/react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Auth from './pages/Auth'
import AppHome from './pages/AppHome'
import Onboarding from './pages/Onboarding'
import ProtectedRoute from './pages/ProtectedRoute'
import Paywall from './pages/Paywall'
import VerifyEmail from './pages/VerifyEmail'
import ToastContainer from './components/ui/Toast'

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div
          style={{
            minHeight: '100vh',
            backgroundColor: '#0A0A0A',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            fontFamily: '-apple-system, sans-serif',
          }}
        >
          <div style={{ textAlign: 'center', maxWidth: '320px' }}>
            <div
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'rgba(255,59,48,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
              }}
            >
              <span
                className="material-icons-outlined"
                style={{ color: '#FF3B30', fontSize: '24px' }}
              >
                error_outline
              </span>
            </div>
            <h2
              style={{
                color: '#FFFFFF',
                fontSize: '20px',
                fontWeight: '700',
                letterSpacing: '-0.4px',
                marginBottom: '8px',
              }}
            >
              Etwas ist schiefgelaufen
            </h2>
            <p
              style={{
                color: 'rgba(255,255,255,0.5)',
                fontSize: '14px',
                lineHeight: '1.5',
                marginBottom: '24px',
              }}
            >
              Wir wurden automatisch benachrichtigt
              und arbeiten daran.
            </p>
            <button
              onClick={resetError}
              style={{
                background: '#00C853',
                color: '#000000',
                fontWeight: '600',
                fontSize: '16px',
                padding: '14px 32px',
                borderRadius: '12px',
                border: 'none',
                cursor: 'pointer',
                width: '100%',
              }}
            >
              Neu laden
            </button>
          </div>
        </div>
      )}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Auth />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <Onboarding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/paywall"
            element={
              <ProtectedRoute>
                <Paywall />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppHome />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  )
}

export default App
